import { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { UserProfileJobHuntingStatus } from '@/types'
import styles from './index.module.scss'
import { JobTitleTag } from '../../atoms/JobTitleTag'
import { sanitizeUrl } from '../../../utils'
import { AvatarWithVerifiedBadge } from '../AvatarWithVerifiedBadge'

type Props = {
  avatar: string
  name: string
  jobTitle?: string
  href: string
  isVerifiedAccount?: boolean
  jobHuntingStatus?: UserProfileJobHuntingStatus
}

export const ProfileCard: FC<PropsWithChildren<Props>> = ({
  children,
  avatar,
  name,
  jobTitle = '',
  href,
  isVerifiedAccount,
  jobHuntingStatus = null,
}) => {
  const { t } = useTranslation('companies-users-[id]')

  return (
    <Link href={sanitizeUrl(href)}>
      <a className={styles.container}>
        <div className={styles.header}>
          <div className={styles.avatar}>
            <AvatarWithVerifiedBadge avatar={avatar} name={name} isVerifiedAccount={isVerifiedAccount} />
          </div>
          <div className={styles.nameContent}>
            <div className={jobTitle || jobHuntingStatus ? styles.nameAndTitle : styles.name}>{name}</div>
            {jobTitle && <JobTitleTag name={jobTitle} isCard />}
            {jobHuntingStatus && <div className={styles.jobHuntingStatus}>{t(jobHuntingStatus)}</div>}
          </div>
        </div>

        <div className={styles.body}>{children}</div>
      </a>
    </Link>
  )
}
